// store/dashboardSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "https://api-workshop.firststepoverseas.com/dashboard";

// Async thunk to fetch dashboard data
export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (_, { rejectWithValue }) => {
    try {
      const access = localStorage.getItem("access"); // token stored from auth
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `JWT ${access}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { detail: "Failed to fetch dashboard data" }
      );
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    role: null,
    webinars: [],
    total_webinars: 0,
    total_attendees: 0,
    total_revenue: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload.role;
        state.webinars = action.payload.webinars || [];
        state.total_webinars = action.payload.total_webinars;
        state.total_attendees = action.payload.total_attendees;
        state.total_revenue = action.payload.total_revenue;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "Unable to load dashboard data";
      });
  },
});

export default dashboardSlice.reducer;
